import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NgHttpService } from '../auth/httpservice';
import { environment } from '@/app/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificacoesService {
    constructor(private http: HttpClient, private _http: NgHttpService) { }

    adicionar(data: any = {}): Observable<any> {
        return this._http.post(environment.apiGeral, `Notificacoes`, data);
    }

    responder(id: string, params: any) {
        return this._http.post(environment.apiGeral, `Notificacoes/${id}/Responder`, params);
    }

    arquivar(id: string): Observable<any> {
        return this._http.post(environment.apiGeral, `Notificacoes/${id}/Arquivar`, {});
    }

    desarquivar(id: string): Observable<any> {
        return this._http.post(environment.apiGeral, `Notificacoes/${id}/Desarquivar`, {});
    }

    listar(params: any = {}): Observable<any> {
        return this._http.get(environment.apiGeral, `Notificacoes`, params);
    }

    recebidasRecente(pageSize: number, offset: number): Observable<any> {
        return this._http.get(environment.apiGeral, `Notificacoes/RecebidasRecente`, { pageSize, offset });
    }

    recebidas(pageSize: number, offset: number): Observable<any> {
        return this._http.get(environment.apiGeral, 'Notificacoes/Recebidas', { pageSize, offset });
    }

    enviadas(pageSize: number, offset: number): Observable<any> {
        return this._http.get(environment.apiGeral, 'Notificacoes/Enviadas', { pageSize, offset });
    }

    arquivadas(pageSize: number, offset: number): Observable<any> {
        return this._http.get(environment.apiGeral, 'Notificacoes/Arquivadas', { pageSize, offset });
    }

    importantes(pageSize: number, offset: number): Observable<any> {
        return this._http.get(environment.apiGeral, 'Notificacoes/Importantes', { pageSize, offset });
    }

    listarPorId(id: string): Observable<any> {
        return this._http.get(environment.apiGeral, `Notificacoes/${id}`, id)
    }

    alterar(id: string, data: any = {}): Observable<any> {
        return this._http.put(environment.apiGeral, `Notificacoes/${id}`, data)
    }

    leitura(id: string): Observable<any> {
        return this._http.put(environment.apiGeral, `Notificacoes/${id}/Leitura`, {});
    }

    excluir(id: string): Observable<any> {
        return this._http.delete(environment.apiGeral, `Notificacoes/${id}`, {});
    }
}
